<template>
  <authorization permissionKey="configuration_facilitator_hma" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de Histórico da Moléstia Atual
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <HMAList
                :facilitators="historyPresentIllnessFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import HMAList from "@/components/config/hma/list/index.vue";

  export default {
    name: "HMAConfig",
    components: {
      HMAList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          introduction: "Introdução",
          complaint: "Queixa",
          procedure: "Procedimento",
          sign: "Sinal",
          site: "Local",
          period: "Tempo",
        },
      };
    },
    apollo: {
      historyPresentIllnessFacilitators: {
        query: require("@/graphql/history_present_illness_facilitators.gql"),
        pollInterval: 20000,
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.historyPresentIllnessFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
